/* eslint-disable */

export const adminGlass = {
  statGrid5: {
    display: "grid",
    gridTemplateColumns: "repeat(5, minmax(0, 1fr))",
    gap: 18,
    alignItems: "stretch",
  },

  statGrid4: {
    display: "grid",
    gridTemplateColumns: "repeat(4, minmax(0, 1fr))",
    gap: 18,
    alignItems: "stretch",
  },

  card: {
    background: "rgba(255,255,255,0.74)",
    borderRadius: 30,
    border: "1px solid rgba(255,255,255,0.76)",
    boxShadow:
      "0 28px 70px rgba(17,32,66,0.09), inset 0 1px 0 rgba(255,255,255,0.72)",
    backdropFilter: "blur(20px)",
    WebkitBackdropFilter: "blur(20px)",
  },

  statCard: {
    minHeight: 132,
    borderRadius: 26,
    padding: "22px 22px",
    background: "rgba(255,255,255,0.78)",
    border: "1px solid rgba(255,255,255,0.78)",
    boxShadow:
      "0 24px 60px rgba(17,32,66,0.08), inset 0 1px 0 rgba(255,255,255,0.72)",
    backdropFilter: "blur(18px)",
    WebkitBackdropFilter: "blur(18px)",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
  },

  panel: {
    background: "rgba(255,255,255,0.74)",
    borderRadius: 30,
    border: "1px solid rgba(255,255,255,0.76)",
    boxShadow:
      "0 28px 70px rgba(17,32,66,0.09), inset 0 1px 0 rgba(255,255,255,0.72)",
    padding: 24,
    backdropFilter: "blur(20px)",
    WebkitBackdropFilter: "blur(20px)",
  },

  softRow: {
    background: "rgba(255,255,255,0.58)",
    border: "1px solid rgba(219,231,255,0.86)",
    boxShadow: "0 10px 24px rgba(17,32,66,0.04)",
    backdropFilter: "blur(14px)",
    WebkitBackdropFilter: "blur(14px)",
  },
};